import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { InventoryService } from './inventory.service';
import { AppService } from '../shared/services/app.service';

@Component({
  selector: 'app-po',
  templateUrl: './po.component.html',
  styleUrls: ['./po.component.css']
})
export class PoComponent implements OnInit {

  inventory:any;
  currDate:any;
  subTotal:number = 0;
  taxTotal:number = 0;
  total:number = 0;

  constructor(
    private _invService: InventoryService,
    private _appService: AppService,
    private _ref: ChangeDetectorRef
  ) {

  }

  ngOnInit() {
    this.currDate = new Date();
      this._invService.poReady$.subscribe(
      data => {
        this._appService.hideLoader();
        this.inventory = data;
        this.getTotals();
      }
    );
  }

  private getTotals() {
    let sub = 0;
    this.inventory.forEach((i) => {
      if(!i.parent) {
        sub = this.getAmount(i) + sub;
      }
    });
    this.taxTotal = sub * .06;
    this.total = sub + this.taxTotal;
    this.subTotal = sub;
    //this._ref.detectChanges();

  }

   private getAmount(i) {
    let cnt = 0;
    if(i.slabCount) {
      cnt = parseInt(i.slabCount);
    }
    let cost = 0;
    if(i.price.slab) {
      cost = parseFloat(i.price.slab);
    }

    return (cnt * cost);
  }



}



// WEBPACK FOOTER //
// ./src/app/inventory/po.component.ts